import * as ko from "knockout"
import { ElementLocationViewModel } from "../ElementLocationViewModel"
import { AccountViewModel } from "../AccountViewModel";
import { XinkImageViewModel } from "./XinkImageViewModel";

export class DroppedPictureElementViewModel extends ElementLocationViewModel {
    imageSrc: KnockoutObservable<string>;
    accountViewModel: KnockoutObservable<AccountViewModel>;

    hasXinkImagesBeenInitialized: boolean;
    isChoosingLocalImage: KnockoutObservable<boolean>;
    isChoosingXinkImage: KnockoutObservable<boolean>;
    xinkImages: KnockoutObservableArray<XinkImageViewModel>;

    private wasShown: boolean;

    constructor(elementType: string, accountViewModel: AccountViewModel) {
        super(elementType);

        this.imageSrc = ko.observable("");
        this.accountViewModel = ko.observable(accountViewModel);

        this.hasXinkImagesBeenInitialized = false;
        this.isChoosingLocalImage = ko.observable(true);
        this.isChoosingXinkImage = ko.observable(false);
        this.isChoosingXinkImage.subscribe((newValue: boolean) => {
            if (newValue && !this.hasXinkImagesBeenInitialized) {
                this.loadXinkImages();
            }
        });
        this.xinkImages = ko.observableArray([]);

        this.wasShown = false;
        let self = this;
        document.addEventListener(
            'scroll',
            function (event) {
                var $elm = $(event.target);
                if ($elm.is('.xink.images.wrapper')) {
                    let wrapper: any = $elm[0];
                    let firstImage = $(".image")[0];
                    let heighOfFirstImage = $(firstImage).height();

                    let scrollHeight = wrapper.scrollHeight;
                    let totalHeight = wrapper.scrollTop + wrapper.clientHeight;

                    if (totalHeight >= scrollHeight - heighOfFirstImage) {
                        if (!self.wasShown) {
                            self.loadXinkImages();
                            self.wasShown = true;
                        }
                    }
                    else {
                        self.wasShown = false;
                    }
                }
            },
            true // Capture event
        );
    }

    setImage(file: File) {
        let reader = new FileReader();
        reader.onload = (e:any) => {
            this.imageSrc(e.target.result);
            this.elementMostLikelyChangedSize();

            if (this.onImageLoaded) {
                this.onImageLoaded(e.target.result);
            }
        }

        reader.readAsDataURL(file);
    }

    onImageLoaded: ((imageSrc: string) => any) | null;

    selectXinkImage(self: DroppedPictureElementViewModel, image: XinkImageViewModel) {
        self.imageSrc(image.imageUrl);
    }

    imageLoaded() {
        this.elementMostLikelyChangedSize();
    }

    flipTab() {
        if (this.accountViewModel().isSignedIn()) {
            this.isChoosingLocalImage(!this.isChoosingLocalImage());
            this.isChoosingXinkImage(!this.isChoosingXinkImage());
        }
    }

    public showXinkImage(element, index) {
        if (element.nodeType === 1) {
            $(element)
                .hide()
                .delay((index % 100) * 30)
                .fadeIn(1000)
                ;
        }
    }

    public clone(): ElementLocationViewModel {
        let ret = new DroppedPictureElementViewModel(this.elementType, this.accountViewModel());
        super.cloneThis(ret);

        ret.imageSrc(this.imageSrc());

        return ret;
    }

    public getData(data): any {
        super.getData(data);
        data.imageSrc = this.imageSrc;
    }

    private loadXinkImages(): void {
        this.accountViewModel().getImages((imageUrls, isDone) => {
            const numberOfDummies = 5;
            for (let i = 0; i < numberOfDummies; i++) {
                this.xinkImages.pop();
            }

            for (let url of imageUrls) {
                this.xinkImages.push(new XinkImageViewModel(url));
            }

            if (!isDone) {
                for (let i = 0; i < numberOfDummies; i++) {
                    this.xinkImages.push(new XinkImageViewModel("", true));
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./code/elements/DroppedPictureElementViewModel.ts